"use client";

import { useApiGet } from "@/hooks/use-api";
import { integrationKeys } from "./keys";
import type { ConnectionsCatalogResponse } from "./types";

/**
 * useConnectionsCatalog
 *
 * Fetches the connector catalog from the backend kernel
 * (GET /api/connections/catalog) — the source of truth for gallery cards
 * and marketplace detail pages. Callers should fall back to the static
 * AVAILABLE_CONNECTIONS list while loading or on error so the settings
 * page never renders empty (e.g. against an older backend).
 *
 * Usage:
 *   const { connectors, isLoading } = useConnectionsCatalog();
 */
export function useConnectionsCatalog() {
  const { data, isLoading, isError, refetch } =
    useApiGet<ConnectionsCatalogResponse>(
      integrationKeys.catalog(),
      "/api/connections/catalog",
      undefined,
      {
        staleTime: 30 * 60 * 1000,
        refetchOnWindowFocus: false,
      },
    );

  return {
    connectors: data?.connectors ?? [],
    isLoading,
    isError,
    refetch,
  };
}
